// extracted by mini-css-extract-plugin
module.exports = {"legendContainer":"Legend_legendContainer__26jgN","checkbox":"Legend_checkbox__13x3a"};